import React, {
    useState,
    useEffect,
    useRef
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _noop from 'lodash/noop';
import Input from '../input';
import CloseIcon from './images/icons/close-x.svg';
import SearchIcon from './images/icons/search.svg';
import SuggestionsList from '../suggestions-list';

const SearchEntry = ({
    onChangeHandler = null,
    onFocusHandler = _noop,
    onClearInputHandler = _noop,
    suggestions = [],
    placeholder = "",
    value = "",
    onSelectItem = null,
}) => {

    const [
        inputVisible,
        setInputVisible,
    ] = useState(false);

    const [
        currentResult,
        setCurrentResult,
    ] = useState(-1);

    const [
        showSuggestions,
        setShowSuggestions,
    ] = useState(true);

    const node = useRef();

    const refInput = useRef();

    useEffect(() => {

        document.addEventListener('click', handleDocumentClick);
        return () => document.removeEventListener('click', handleDocumentClick);

    }, []);

    useEffect(() => {

        setShowSuggestions(suggestions && suggestions.length > 0);
        setCurrentResult(-1);

    }, [suggestions]);

    useEffect(() => {

        if (inputVisible) {

            refInput.current.focus();

        }

    }, [inputVisible]);

    const selectItem = (item) => {

        onSelectItem(item);
        setInputVisible(false);
        refInput.current.blur();

    };

    const clearInput = () => {

        onClearInputHandler();
        setShowSuggestions(false);
        refInput.current.blur();

    };

    const handleDocumentClick = (e) => {

        if(!node.current.contains(e.target)) {

            setShowSuggestions(false);

        }

    };

    const handleKeyDown =({ keyCode }) => {

        const down = keyCode === 40;
        const up = keyCode === 38;
        const enter = keyCode === 13;
        const esc = keyCode === 27;
        if (down && currentResult < suggestions.length - 1) {

            setCurrentResult(currentResult + 1);

        }
        if (up && currentResult > -1) {

            setCurrentResult(currentResult - 1);

        }
        if (enter) {

            if (currentResult > -1) {

                selectItem(suggestions[currentResult].tagUrl);

            } else if (suggestions.length > 0) {

                selectItem(suggestions[0].tagUrl);

            }

        }
        if (esc) {

            setInputVisible(false);
            clearInput();

        }

    };

    const handleBtnClick = () => {

        if (inputVisible) {

            clearInput();

        }

        setInputVisible(!inputVisible);

    };

    const handleItemClick = (tagUrl) => {

        selectItem(tagUrl);

    };

    const inputFocus = () => {

        if (!inputVisible) {

            setInputVisible(true);

        }
        onFocusHandler();

    };

    const searchEntryClass = classNames({
        'search-entry': true,
        'search-entry--input-visible': inputVisible,
    });

    const btnIconSrc = inputVisible ? CloseIcon : SearchIcon;

    return(
        <div className={searchEntryClass} ref={node}>
            <button className="search-entry__btn" onClick={handleBtnClick}>
                <img className="search-entry__btn-icon" src={btnIconSrc} />
            </button>
            <div className="search-entry__input">
                <Input
                    ref={refInput}
                    onChangeHandler={onChangeHandler}
                    placeholder={placeholder}
                    icon={SearchIcon}
                    onKeyDown={handleKeyDown}
                    value={value}
                    onFocus={inputFocus}
                />
                {showSuggestions && !!suggestions.length && <SuggestionsList onItemClick={handleItemClick} suggestions={suggestions} active={currentResult} />}
            </div>
        </div>
    );

};

SearchEntry.propTypes = {
    onChangeHandler: PropTypes.func,
    onFocusHandler: PropTypes.func,
    suggestions: PropTypes.array,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onSelectItem: PropTypes.func,
};

export default SearchEntry;
